export enum OCPP_CONNECTION_STATUS {
  DISCONNECTED = 0,
  NOT_CONFIGURED = 1,
  CONNECTION_REJECTED = 2,
  CONNECTION_ERROR = 3,
  CONNECTED = 4
}
